// extracted by mini-css-extract-plugin
export default {"ContributorFooterContainer":"ContributorFooter-module__ContributorFooterContainer--eg0td","infoIconWrapper":"ContributorFooter-module__infoIconWrapper--NL_hK"};